import { supabaseClient } from "@/lib/supabase";

/** Choice inputs whose rows the migration may own. A shared dictionary is left alone. */
const OWNED_CHOICE_KEYS = new Set([
    "single-choice",
    "multiple-choice",
    "dropdown",
    "scale-rating",
    "slider",
    "measurement",
    "ms-adl-selection",
    "visa-a-8",
    "visa-g-8",
    "visa-p-8",
    "visa-h-8",
]);

/**
 * After a builder save, rewrite option rows that belong to this input.
 * No-op when the input has no rows yet, or when a dictionary owns the list.
 */
export async function syncOwnedInputChoices(input: {
    input_id?: string | null;
    input_key?: string | null;
    dictionary_id?: string | null;
}): Promise<void> {
    if (!input.input_id || !input.input_key) return;
    if (input.dictionary_id != null) return;
    if (!OWNED_CHOICE_KEYS.has(input.input_key)) return;
    const { error } = await supabaseClient.rpc("replace_input_owned_choices", {
        p_input_id: input.input_id,
    });
    if (error) throw error;
}
